module.exports = __webpack_public_path__ + "a35998dc5e2da9e621cd4fb92466caae.png";